import styled from 'styled-components'
import { devices } from '../../../../globalStyle'
export const Container = styled.div`
    position: absolute;
    top: 50vh;
    left: 50vw;
    transform: translate(-50%, -50%);
    background-color: #fff;
    border-radius: 1vw;
    z-index: 1;
    width: 70%;
`
export const GridContainer = styled.div `
    display: grid;
    grid-template-areas:
    "titleNew titleNew titleNew titleNew"
    "cep cep street street"
    "neighborhood neighborhood state number"
    "complement complement city city"
    "line line line line"
    "name name days hours";
    gap: 1rem;
    border: 1px dashed #ccc; /* Bordas para depuração */
    grid-template-columns: repeat(4, minmax(200px, 1fr));
    grid-template-rows: auto; /* Alturas dinâmicas */
    padding: 2rem; /* Adiciona espaçamento interno */
    gap: 0rem; /* Espaço entre os elementos */
`
export const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 62.5vw;
    margin-top: 0.8rem;
    margin-left: 1.2vw;
    margin-right: 0.7vw;
`

export const OptionsDiv = styled.div `
    display: flex;
    justify-content: flex-end;
    grid-area: options;
    margin-top: 1vw;
    margin-bottom: 1vw;
`
export const HeaderText = styled.h2`
    font-family: 'Inter', sans-serif;
    font-size: 1.4vw;
    font-weight: 700;
    margin-top: 0;
    margin-bottom: 0;
`

export const CloseDiv = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 2vw;
    cursor: pointer;
    width: 2.5vw;
    height: 2.5vw;

    :hover{
        background-color: #F4F4F4;
    }
`

export const CloseImg = styled.img`
    width: 0.8vw;
`

export const InputDiv = styled.div`
    margin-left: 0.92rem;
    margin-top: 1.2rem;
    position: relative;

    .empty {
        border: 0;
    }

    .isDisabled {
       cursor: not-allowed;
    }
`

export const InputLabel = styled.label`
    display: block;
    font-family: 'Inter', sans-serif;
    font-weight: 700;
    font-size: clamp(0.7rem, calc(0.7rem + 0.1vw) , 1.5rem);
`

export const Input = styled.input`
    width: 9.5vw;
    height: 5.3vh;
    background-color: #EBEBEB;
    border: 0;
    border-radius: 2vw;
    margin-top: 0.8vh;
    margin-right: 1vh;
    padding-left: 1vw;
    padding-right: 1vw;
    font-size: 1vw;
    width: 100%;
    color: #696969;
    :focus {
        outline: 0;
    }
        ::placeholder {
    color: #999;
    font-style: italic;
  }
`
export const ButtonOfSection = styled.div`
  display: flex;
  align-items: center;
  width: auto;
  height: 2.2vw;
  background-color: #0090d3;
  border-radius: 1vw;
  cursor: pointer;
  padding:.7vw;
  margin-right: 3vw;
  @media ${devices.largeDesktop} {
    width: 10vw;
  }

  &.reverse{
    background-color: #fff;
    border: 1px solid #0090d3;
  }
`
export const LineDiv = styled.div`
     background: #EBEBEB;
    /* background: red; */
    height: 0.1px;
    grid-area: line;
    
    margin-top: 0.5vw;
`

export const PlusImg = styled.img`
  display: flex;
  height: 1.5vw;
  margin-right: 0.5vw;

  @media ${devices.largeDesktop} {
    height: 1vw;
  }
`

export const ButtonOfSectionText = styled.p`
  color: #fff;
  font-weight: 600;
  font-size: 0.9vw;
  font-family: 'Inter', sans-serif;
  font-weight:700;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }

  &.reverse{
    color: #0090d3;
  }
`